import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA({
  onCtaClick
}: {
  onCtaClick: () => void;
}) {
  return <section className="py-24 bg-[#5C4033] text-[#FFF8F0] px-4 text-center relative overflow-hidden" data-id="element-60">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/wood-pattern.png')]" data-id="element-61"></div>

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="relative z-10 max-w-4xl mx-auto" data-id="element-62">
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-63">
          Volvé a lo simple. <br data-id="element-64" />
          <span className="text-[#D4A5A5] italic" data-id="element-65">
            Volvé a lo que siempre funcionó.
          </span>
        </h2>

        <p className="text-lg md:text-xl text-[#E5D0C5] mb-10 max-w-2xl mx-auto" data-id="element-66">
          Accedé hoy al Manual Secreto de la Abuela 2.0 y empezá a resolver lo
          cotidiano de forma natural.
        </p>

        <button onClick={onCtaClick} className="bg-[#FFF8F0] text-[#5C4033] hover:bg-[#E5D0C5] px-10 py-4 rounded-lg text-lg font-bold transition-all shadow-lg hover:shadow-white/10 flex items-center gap-2 mx-auto" data-id="element-67">
          Descargar ahora
          <ArrowRight className="w-5 h-5" data-id="element-68" />
        </button>
      </motion.div>
    </section>;
}